import './index.html';
import './style.scss';
import {getCurrentScene} from "../../scripts/site_functions/getCurrentScene";
import {audios, sceneNamePrefix} from "../../scripts/site_functions/constants";
import {allCollectedScenes} from "../../scripts/general/popup-init";

export default async () => {
  const loaderElement = document.querySelector('.red-boat-loader');
  const posters = document.querySelectorAll(".poster")
  posters[window.currentScene].classList.add('active-now')
  for (let i = 0; i < posters.length; i++) {
    const poster = posters[i]
    poster.addEventListener('click', async () => {
      if (i === window.currentScene) return;
      loaderElement.classList.add('active')
      audios[sceneNamePrefix + (window.currentScene + 1)]?.map(audio => audio.pause())
      window.allowGTM && window.dataLayer.push({'event':'exit-scene','scene':window.currentScene+1});
      await getCurrentScene(window.currentScene = i);
    })
  }
  window.addEventListener('scene-changed', event => {
    for (let i = 0; i < posters.length; i++) {
      posters[i].classList.toggle('active-now', i === event.detail)
    }
  })
  window.addEventListener('scene-completed', () => {
      posters[window.currentScene].classList.add('active')
  })
  window.addEventListener('trigger-clicked', event => {
    posters[window.currentScene].querySelector(`.small-dot:nth-of-type(${event.detail})`)?.classList.add('active')
  })
};

